import React, { FC, ReactNode } from 'react'
import { ShepherdOptionsWithType, ShepherdTour, TourMethods } from 'react-shepherd'
import { TourEvents } from '..'
import { StyledTour } from '.'

type Props = {
  _id: string;
  steps?: ShepherdOptionsWithType[];
  children: ReactNode;
  canStart?: boolean;
  onTourComplete?: () => void;
}

const Tour: FC<Props> = ({
  _id, steps, children, canStart, onTourComplete
}) => {
  if (!steps?.length) {
    return <></>
  }

  return (
    <>
      <StyledTour />
      <ShepherdTour
        steps={steps}
        tourOptions={{
          tourName: _id,
          defaultStepOptions: {
            arrow: false,
            cancelIcon: { enabled: false },
            modalOverlayOpeningRadius: 6,
            popperOptions: { modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }
          },
          useModalOverlay: true,
          exitOnEsc: true
        }}
      >
        <TourMethods
          children={(tour) => (
            <TourEvents
              tour={tour}
              tourId={_id}
              canStart={canStart}
              onTourComplete={onTourComplete}
            />
          )}
        />
        {children}
      </ShepherdTour>
    </>
  )
}

export default Tour
